import { z } from 'zod';
/**
 * The walking skeleton's contract. Small, but it is the thing that proves the whole
 * stack is wired: SPA -> API -> Postgres -> Redis and back, with the response validated
 * against a schema both sides share.
 */
export const dependencyStatusSchema = z.object({
    name: z.string(),
    status: z.enum(['up', 'down']),
    latencyMs: z.number().nonnegative(),
    detail: z.string().optional(),
});
export const healthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    service: z.literal('handynest-api'),
    version: z.string(),
    uptimeSeconds: z.number().nonnegative(),
    checkedAt: z.string().datetime(),
    dependencies: z.array(dependencyStatusSchema),
});
//# sourceMappingURL=health.js.map